/**
 * Component that allows the customer to configure his new mortgage based on the offers provided from the bank.
 */
import { Grid, Paper, styled } from "@mui/material";
import React from "react";

import DurationConfigurator from "./DurationConfigurator";
import PaymentConfigurator from "./PaymentConfigurator";
import RepaymentConfigurator from "./RepaymentConfigurator";

const StyledPaper = styled(Paper)(({ theme }) => ({
    [theme.breakpoints.up("lg")]: {
        maxHeight: "221px",
    },
}));

const Configurator = () => {
    return (
        <StyledPaper elevation={6} square={false} data-cy={"configurator"}>
            <Grid container>
                <DurationConfigurator />
                <PaymentConfigurator />
                <RepaymentConfigurator />
            </Grid>
        </StyledPaper>
    );
};

export default Configurator;
